import { Backdrop, CircularProgress, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Action from "../../../../action/api";
import API from "../../../helpers/endpointservice";
import CommonIcon from "../../../helpers/icons";
const GoogleMeet = ({setValuesChanged}) => {
  const [showUpdate, setshowUpdate] = useState(false);
  const handleUpdate = () => {
    setshowUpdate(true);
    setValuesChanged(true);
  };

  const [fileDetails, setFileDetails] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    getFileDetails();
  }, []);

  const getFileDetails = () => {
    setLoading(true);
    Action.GET(API.GoogleUpload)
      .then((res) => {
        if (res.data) {
          setFileDetails(res.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
      setError(false);
    }
  };

  const [error, setError] = useState(false);
  const handleFileUpload = () => {
    if (selectedFile) {
      setError(false);
      const formData = new FormData();
      formData.append("file", selectedFile);
      setLoading(true);
      Action.POST(API.GoogleUpload, formData)
        .then((res) => {
          setSelectedFile(null);
          setFileName("");
          setshowUpdate(false);
          setValuesChanged(false);
          setLoading(false);
          getFileDetails();
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } else {
      setError(true);
    }
  };

  const closeUpdate = () => {
    setValuesChanged(false);
    setshowUpdate(false);
    setError(false);
    setSelectedFile(false);
    setFileName(false);
  };

  const downloadBase64File = (fileData) => {
    const { base64Data, fileName, contentType } = fileData;

    // Decode base64 and create a Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    // Create a download link and trigger it
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFile = () => {
    setLoading(true);
    Action.GET(API.GoogleDownload)
      .then((res) => {
        if (res.data) {
          downloadBase64File(res.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const DeleteFile = () => {
    setLoading(true);
    Action.DELETE(API.GoogleDelete)
      .then((res) => {
        setLoading(false);
        getFileDetails();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const [isloading, setLoading] = useState(false);

  return (
    <>
      <Backdrop className="spinner-backdrop" open={isloading}>
        <CircularProgress color="primary" />
      </Backdrop>
      {!showUpdate && (
        <div className="row">
          <di className="row">
            {/* <div className="col-lg-2 col-md-2 col-sm-12">
              <span className="joblable">Google Meet</span>
            </div> */}
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row">
                <div className="col-10  mb-2 ssocontent">
                  <FormLabel
                    className="formlabel-style w-100 mb-2"
                    id="first-name-label"
                  >
                    Secret JSON
                  </FormLabel>
                  <div className="d-flex align-items-center">
                    <span className="formlabel-input">
                      {fileDetails?.fileName}
                    </span>
                    {fileDetails?.fileName && (
                      <>
                        <span
                          className="ms-2 cursor-pointer"
                          onClick={() => {
                            downloadFile();
                          }}
                        >
                          <CommonIcon fileName={"downloadBlue"} />
                        </span>
                        <span
                          onClick={() => {
                            DeleteFile();
                          }}
                          className="ms-2 cursor-pointer"
                          style={{ marginTop: "-2px" }}
                        >
                          <CommonIcon fileName={"DeleteIcon"} />
                        </span>
                      </>
                    )}
                  </div>
                  <div className="col-12  ssobutton">
                    <button
                      className="btn-action mt-10 mr-10 border-none"
                      variant="primary"
                      onClick={() => handleUpdate()}
                    >
                      Edit
                    </button>{" "}
                  </div>
                </div>
              </div>
            </div>
          </di>
        </div>
      )}
      {showUpdate && (
        <div className="row">
          <div className="row">
            {/* <div className="col-lg-2 col-md-2 col-sm-12">
              <span className="joblable">Google Meet</span>
            </div> */}
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row">
                <div className="col-10">
                  <FormLabel
                    className="formlabel-style w-100 mb-2 "
                    id="first-name-label"
                  >
                    Secret JSON
                  </FormLabel>
                  <label htmlFor="customFileLang" style={{ cursor: "pointer",display:'block' }}>
                    <CommonIcon fileName={"FileUpload"} />
                  </label>
                  <span className="uploadedFile">{fileName||"Only JSON file is supported"}</span>
                  <div className="custom-file d-none">
                    <input
                      type="file"
                      className="custom-file-input d-none"
                      id="customFileLang"
                      lang="es"
                      data-toggle="tooltip"
                      onChange={handleFileChange}
                      accept=".json"
                    />
                    <label className="custom-file-label">{fileName}</label>
                  </div>
                </div>
                {error && (
                  <div className="mui-error-text mt-2">
                    Please upload a JSON file.
                  </div>
                )}
                <div className="col-10 mt-2">
                  <button
                    className={`btn-fun btn-action btn-filter-action`}
                    variant="primary"
                    onClick={() => {
                      handleFileUpload();
                    }}
                  >
                    Upload
                  </button>
                  <Button
                    className="btn-cancel mt-8"
                    variant="outlined"
                    onClick={() => {
                      closeUpdate();
                    }}
                  >
                    Cancel
                  </Button>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GoogleMeet;
